export enum MedicationStatusEnum {
  ACTIVE = 'Active',
  INACTIVE = 'Inactive',
  ALL = 'All',
}
